import React from 'react';

const DeviceTableHeaderResizeSlider = (props) => {
  return (
    <div className="DeviceTableHeader_ResizerSliderIcon">
      <div className="DeviceTableHeader_ResizerSliderIcon_Bar"></div>
    </div>
  );
};

export default DeviceTableHeaderResizeSlider;
